export const name = "ATAN2";
export const summary = `Computes the inverse tangent of \`X/Y\`, using the signs of \`X\` and \`Y\` to determine the quadrant.`;
export const reference = `
## ATAN2

Computes the inverse tangent of \`X/Y\`, using the signs of \`X\` and \`Y\` to determine the quadrant.

\`\`\`
ATAN2(X, Y)
\`\`\`

### Description

Calculates the principal value of the inverse tangent of X/Y using the signs of the two arguments to determine the quadrant. The return value is in the range [-π,π].

| X | Y | ATAN2(X, Y) |
| --- | --- | --- |
| \`NaN\` | Any value | \`NaN\` |
| Any value | \`NaN\` | \`NaN\` |
| 0.0 | 0.0 | 0.0 |
| Positive Finite value | \`-inf\` | π |
| Negative Finite value | \`-inf\` | -π |
| Finite value | \`+inf\` | 0.0 |
| \`+inf\` | Finite value | π/2 |
| \`-inf\` | Finite value | -π/2 |
| \`+inf\` | \`-inf\` | ¾π |
| \`-inf\` | \`-inf\` | -¾π |
| \`+inf\` | \`+inf\` | π/4 |
| \`-inf\` | \`+inf\` | -π/4 |


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/mathematical_functions
`;
